var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Utils, PropertyConverters, Components, stopPropagationHandler, ViewChild, avoidHandler } from '@pacem/pacem-core';
import { LightboxBehavior } from './lightbox-abstractions';
import { PacemButtonElement } from './button';
//namespace Pacem.Components.UI {
// TODO: shadow-ize lightbox (slots, parts, ...) in the next version 0.5x.x.
let PacemLightboxElement = class PacemLightboxElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this._keyupHandler = (evt) => {
            if (evt.keyCode === 27 /* ESC */ && this.show && !this.modal) {
                this.show = false;
            }
        };
        this._wrapperMousedownHandler = (evt) => {
            if (this.modal || this.behavior === LightboxBehavior.ExplicitClose) {
                stopPropagationHandler(evt);
            }
            else {
                this.show = false;
            }
        };
        this._slotchangeHandler = (evt) => {
            this._resetLayout();
        };
        this._closeHandler = (evt) => {
            this._close(evt);
        };
    }
    _resetLayout() {
        this._disposeButton();
        const btn = this._ensureButton();
        if (!Utils.isNull(btn)) {
            btn.addEventListener('click', this._closeHandler, false);
        }
    }
    _toggleCloseVisibility() {
        const closer = this._closeWrapper;
        if (!Utils.isNull(closer)) {
            closer.hidden = this.modal;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._toggleCloseVisibility();
        var wrapper = this._wrapperElement;
        var container = this._container;
        wrapper.addEventListener('mousedown', this._wrapperMousedownHandler, false);
        container.addEventListener('mousedown', stopPropagationHandler, false);
        document.body.removeEventListener('scroll', avoidHandler, true);
        window.addEventListener('keyup', this._keyupHandler, false);
        this._resetLayout();
        this._slot.addEventListener('slotchange', this._slotchangeHandler, false);
        if (this.show) {
            this._toggle(true);
        }
    }
    _toggle(val) {
        const wrap = this._wrapperElement;
        const container = this._container;
        if (!!val) {
            this.inert = false;
            this.dispatchEvent(new Event('open', { bubbles: true, cancelable: false }));
            wrap.style.display = '';
            wrap.hidden = false;
            window.requestAnimationFrame(() => {
                Utils.addPart(wrap, 'lightbox-wrapper-shown');
                Utils.addPart(container, 'lightbox-shown');
            });
            var scroller = this.querySelector('.' + PCSS + '-scrollable');
            if (scroller) {
                window.requestAnimationFrame(() => scroller.scrollTop = 0);
            }
        }
        else {
            this.inert = true;
            this.dispatchEvent(new Event('close', { bubbles: true, cancelable: false }));
            //
            Utils.removePart(wrap, 'lightbox-wrapper-shown');
            Utils.removePart(container, 'lightbox-shown');
            Utils.addAnimationEndCallback(wrap, (e) => {
                e.hidden = true;
                e.style.display = 'none';
            }, 500);
        }
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (first) {
            return;
        }
        switch (name) {
            case 'show':
                if (!!val) {
                    this._toggle(true);
                }
                else if (!!old) {
                    this._toggle(false);
                }
                break;
            case 'modal':
                this._toggleCloseVisibility();
                break;
        }
    }
    disconnectedCallback() {
        if (this.show) {
            this._close();
        }
        var wrapper = this._wrapperElement;
        var container = this._container;
        document.body.removeEventListener('scroll', avoidHandler, true);
        if (!Utils.isNull(wrapper)) {
            wrapper.removeEventListener('mousedown', this._wrapperMousedownHandler, false);
        }
        if (!Utils.isNull(container)) {
            container.removeEventListener('mousedown', stopPropagationHandler, false);
        }
        window.removeEventListener('keyup', this._keyupHandler, false);
        this._disposeButton();
        this._disposeSlot();
        super.disconnectedCallback();
    }
    _disposeButton() {
        this.#btn?.removeEventListener('click', this._closeHandler);
        this.#btn = null;
    }
    _disposeSlot() {
        this._slot?.removeEventListener('slotchange', this._slotchangeHandler, false);
    }
    _close(evt) {
        if (!Utils.isNull(evt)) {
            avoidHandler(evt);
        }
        this.show = false;
    }
    #btn;
    _ensureButton() {
        if (!Utils.isNull(this.#btn)) {
            return this.#btn;
        }
        const btnSlot = this._slot;
        if (Utils.isNull(btnSlot)) {
            return null;
        }
        const found = this._lookForAButton();
        if (!Utils.isNull(found)) {
            return this.#btn = found;
        }
        const retval = new PacemButtonElement();
        retval.setAttribute('slot', 'close');
        retval.className = `${PCSS}-margin margin-0 ${PCSS}-rise rise--2 button-circle circle-smaller`;
        retval.iconGlyph = 'close';
        this.appendChild(retval);
        return this.#btn = retval;
    }
    _lookForAButton() {
        const btnSlot = this._slot;
        if (Utils.isNull(btnSlot)) {
            return null;
        }
        const buttons = btnSlot.assignedElements({ flatten: true });
        if (Utils.isNullOrEmpty(buttons)) {
            return null;
        }
        return buttons[0];
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemLightboxElement.prototype, "show", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemLightboxElement.prototype, "modal", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemLightboxElement.prototype, "behavior", void 0);
__decorate([
    ViewChild('.' + PCSS + '-lightbox-wrapper')
], PacemLightboxElement.prototype, "_wrapperElement", void 0);
__decorate([
    ViewChild('.' + PCSS + '-lightbox')
], PacemLightboxElement.prototype, "_container", void 0);
__decorate([
    ViewChild('slot[name=close]')
], PacemLightboxElement.prototype, "_slot", void 0);
__decorate([
    ViewChild('div[part=close]')
], PacemLightboxElement.prototype, "_closeWrapper", void 0);
PacemLightboxElement = __decorate([
    CustomElement({
        tagName: P + '-lightbox',
        shadow: true,
        template: `<div class="${PCSS}-lightbox-wrapper" part="lightbox-wrapper" hidden>
        <div class="${PCSS}-lightbox" part="lightbox">
            <div part="top"><slot name="top"></slot></div>
            <div class="${PCSS}-scrollable" part="scrollable">
                <slot></slot>
            </div>
            <div part="bottom"><slot name="bottom"></slot></div>
            <div part="close">
                <slot name="close"></slot>
            </div>
        </div>
</div>`
    })
], PacemLightboxElement);
export { PacemLightboxElement };
//}
